package fi.bullpen.kmpapp.data.bullpen.responses

import kotlinx.serialization.Serializable

@Serializable
data class UsersTurnkeyInfo(
    val organizationId: String,
    val userId: String,
)